<template>
    <div v-if="companies">
        <v-container grid-list-md fluid v-if="!displayAnalysis" style="min-width: 1200px">
            <v-row no-gutters class="pb-4">
                <v-col cols="2" class="d-flex align-center">
                    <v-btn-warning @click="displayAnalysis = true" size="small"> </v-btn-warning>
                    <!--
                    <v-col
                        cols="1"
                        class="pl-2"
                    >
                        <v-select
                            v-model="selectString"
                            :items="selectChoice"
                            outlined dense
                            :hide-details="true"
                            class="oss-"
                        >
                        </v-select>

                    </v-col>
                    -->
                </v-col>
                <v-col cols="8" class="d-flex align-center">
                    <v-text-field-filled
                        v-model="filter.search"
                        :label="searchLabel"
                        append-inner-icon="$search"
                        data-cy="companiesTable-search"
                        density="compact"
                        @click:clear="filter.search = ''"
                        clearable
                    />
                </v-col>
                <v-col cols="2" class="d-flex justify-end align-center">
                    <v-btn @click="dialog = true" :disabled="btnDisabled" size="small">
                        Regrouper
                    </v-btn>
                </v-col>
            </v-row>

            <v-data-table-server
                v-model="selectedRows"
                :items="selectData"
                :headers="dataHeader"
                :page="filter.page"
                :sort-by="filter.sortBy"
                :items-per-page="filter.rowsPerPage"
                :items-length="filter.totalItems"
                class="table"
                :height="'79vh'"
                :multi-sort="false"
                fixed-header
                hide-default-footer
                :show-select="true"
            >
                <template v-slot:item.name="{ item }">
                    {{ getFullCompanyName(item) }}
                </template>
                <template v-slot:item.siret="{ value }">
                    {{ value }}
                </template>
                <template v-slot:item.siren="{ value }">
                    {{ value }}
                </template>
                <template v-slot:item.parentCompany="{ item }">
                    {{ getParentCompanyName(item.parentCompany) }}
                </template>
                <template v-slot:item.activities="{ item }">
                    {{ getActivityName(item.activities) }}
                </template>
                <template v-slot:item.groupKey="{ item }">
                    <v-row v-if="item.groupKey" no-gutters>
                        <v-col cols="9">
                            <v-btn
                                rounded
                                elevation="0"
                                @click="searchGK(item)"
                                size="small"
                                color="filled"
                            >
                                {{ item.groupKey }}
                            </v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn-trash @click="deleteGroupKey(item)" size="small" />
                        </v-col>
                    </v-row>
                </template>
                <template #top>
                    <v-row no-gutters class="d-flex justify-end border-b">
                        <v-spacer />
                        <v-col cols="3" class="d-flex justify-end align-center">
                            <v-select
                                v-model="filter.rowsPerPage"
                                :items="[5, 10, 25]"
                                hide-details
                                class="top-pagination"
                                style="min-width: 170px"
                                prefix="Lignes par page"
                            />
                            <span style="white-space: nowrap">
                                {{ (filter.page - 1) * filter.rowsPerPage + 1 }} -
                                {{ (filter.page - 1) * filter.rowsPerPage + filter.rowsPerPage }}
                                de {{ filter.totalItems }}
                            </span>
                            <v-btn-prev
                                @click="filter.page--"
                                :disabled="filter.page === 1"
                                size="small"
                            />
                            <v-btn-next
                                @click="filter.page++"
                                :disabled="nextPageDisabled"
                                size="small"
                            />
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:header.groupKey="{ column }">
                    <v-row no-gutters>
                        <v-col class="d-flex justify-center align-center">
                            {{ column.title }}
                            <v-select
                                v-model="filter.groupKeySearch"
                                :items="allGroupKeys"
                                placeholder="Rechercher une clef"
                                clearable
                                class="small-select-font"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </template>
            </v-data-table-server>
        </v-container>
        <GroupKeyAnalysis v-else @analysis-done="closeAnalyze()" @group-done="dataAnalysis">
        </GroupKeyAnalysis>
        <oss-dialog v-model="dialog" :actions="actions" title max-width="66vw">
            <MergeGroupKeys
                :companiesId="selectedRows"
                :actions="actions"
                ref="mergeGroupKeyIndex"
                @merge-done="closeDialog()"
            />
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { DialogAction } from "../services/dialogAction";

import COMPANIES_GK_MERGE from "../graphql/company/CompaniesGroupKeysMerge.gql";
import COMPANIES_GK from "../graphql/company/CompaniesGroupKeys.gql";
import COMPANIES_GK_DELETE from "../graphql/company/DeleteGroupKey.gql";

import MergeGroupKeys from "./MergeGroupKeys.vue";
import OssDataTable from "./ossComponents/ossDataTable2.vue";
import GroupKeyAnalysis from "./GroupKeyAnalysis.vue";
import { getGroupKeyQuery } from "../services/graphqlServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        MergeGroupKeys,
        OssDataTable,
        GroupKeyAnalysis,
    },
})
export class CompanyCluster extends Vue {
    @Prop() value: any;

    search: string = "";

    dialog: boolean = false;

    displayAnalysis: boolean = false;

    selectedRows = [];

    selectChoice = ["Tout", "GroupKey", "Siret/Siren", "Compagnie parent"];

    selectString = this.selectChoice[0];

    get searchLabel() {
        return "Rechercher (SIRET, Nom de la société)"; // , Activité
    }

    actions = { action: new DialogAction() };

    get btnDisabled() {
        if (this.selectedRows.length > 1) {
            return false;
        }
        return true;
    }

    filter = {
        search: "",
        groupKeySearch: undefined,
        pagination: {},
        page: 1,
        sortBy: [{ key: "date" as string, order: "desc" as boolean | "desc" | "asc" }],
        rowsPerPage: 10,
        totalItems: 0,
    };

    get nextPageDisabled() {
        return Math.ceil(this.filter.totalItems / this.filter.rowsPerPage) <= this.filter.page;
    }

    @Apollo({
        query: COMPANIES_GK_MERGE,
        variables() {
            return getGroupKeyQuery(this.filter);
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.companies = data.companies;
                    this.filter.totalItems = data.companiesConnection.aggregate.count;
                } else {
                    this.companies = [];
                }
            }
        },
    })
    companies: any = [];

    @Apollo({
        query: COMPANIES_GK,
        variables() {
            return {
                id: "",
                siret: "",
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                const groupedKeys = data.companies.map((company) => company.groupKey);
                this.allGroupKeys = groupedKeys.filter((x) => x !== null && x !== undefined);
            } else {
                this.allGroupKeys = [];
            }
        },
    })
    allGroupKeys: any = [];

    dataHeader = [
        { title: "Nom", value: "name", sortable: false },
        { title: "SIRET", value: "siret", sortable: false },
        { title: "SIREN", value: "siren", sortable: false },
        { title: "Compagnie parent", value: "parentCompany", sortable: false },
        { title: "Activité", value: "activities", sortable: false },
        { title: "GroupKey", value: "groupKey", sortable: false },
    ];

    get selectData() {
        if (this.selectString === "Tout") {
            return this.companies.filter(
                (company) => company.siret || company.siren || company.parentCompany,
            );
        }
        if (this.selectString === "Siret/Siren") {
            return this.companies.filter((company) => company.siret || company.siren);
        }
        if (this.selectString === "GroupKey") {
            return this.companies.filter((company) => company.groupKey);
        }
        if (this.selectString === "Compagnie parent") {
            return this.companies.filter((company) => company.parentCompany);
        }
        return this.companies;
    }

    searchGK(item) {
        this.filter.groupKeySearch = item.groupKey;
    }

    getFullCompanyName(company) {
        let name = company.name;
        if (company.legalUnitName && company.legalUnitName !== name) {
            name += " (" + company.legalUnitName + ")";
        }
        if (company.tradeName && company.tradeName !== name) {
            name += " (" + company.tradeName + ")";
        }
        if (company.shortname && company.shortname !== name) {
            name += " (" + company.shortName + ")";
        }
        return name;
    }

    getActivityName(activity) {
        if (activity?.length) {
            const act = activity[0];
            if (act) {
                return act.name;
            }
        }
        debugger;
        return "";
    }

    getParentCompanyName(item) {
        if (item) {
            return item.name;
        }
    }

    emptyMergingList() {
        // this.search = ""
        this.selectedRows = [];
    }

    closeDialog() {
        this.dialog = false;
        this.emptyMergingList();
    }

    closeAnalyze() {
        this.displayAnalysis = false;
        this.emptyMergingList();
    }

    dataAnalysis(currentCompanies) {
        this.selectedRows = currentCompanies.currentCompanies;
        this.dialog = true;
    }

    async deleteGroupKey(item) {
        await this.$apollo.mutate({
            mutation: COMPANIES_GK_DELETE,
            variables: {
                companies: item,
            },
        });
        this.emptyMergingList();
    }
}

export default toNative(CompanyCluster);
</script>

<style lang="scss">
.top-pagination {
    .v-text-field__prefix {
        font-size: 0.75rem !important;
        font-weight: bold;
    }
    .v-field {
        font-size: 0.875rem !important;
        font-weight: 500;
    }
}

.small-select-font {
    .v-select__selection-text {
        font-size: 0.75rem !important;
        font-weight: 500;
    }
}
</style>
